import { DomainTranslations, ELocale } from 'App/i18n/i18n.types';

import Domain from 'commons/utils/domains';

import esAR from './dashboard.es-AR.json';
import esMX from './dashboard.es-MX.json';
import ptBR from './dashboard.pt-BR.json';

const dashboardTranslations: DomainTranslations = {
  name: Domain.DASHBOARD,
  languages: {
    [ELocale.ARGENTINA]: esAR,
    [ELocale.MEXICO]: esMX,
    [ELocale.BRAZIL]: ptBR
  }
};

export default dashboardTranslations;
